import { createContext, useContext } from 'react';
import { AuthContext } from './AuthProvider';
import { useAccess } from '../hooks/useAccess';

export const AccessContext = createContext();

export const AccessProvider = (props) => {
	const { user } = useContext(AuthContext);
	const { hasAccess, accessType, loading, recheckAccess } = useAccess(user);

	return (
		<AccessContext.Provider
			value={{ hasAccess, accessType, loading, recheckAccess }}
		>
			{props.children}
		</AccessContext.Provider>
	);
};
